export default function PHP_fetch_field_direct() {
  return (
    <div>
      <h1>PHP_fetch_field_direct</h1>
    </div>
  );
}
